import admpNewsSearchData from '@/shared/model/smallPayloadModels/admpNewsSearchData';
import { AdmpNewsState } from './types';

export const state = (): AdmpNewsState => initialState();

export const initialState = (): AdmpNewsState => ({
  isTableView: false,
  admpNewsSearchData: admpNewsSearchData.defaultData(),
  admpNewsContactType: undefined,
  admpNewsImages: {},
  unreadNews: 0,
  admpNewsDashboad: [],
  isAdmpNewsDashboardIsLoading: undefined,
  AdmpNews: {
    //TODO remove when was made backend
    items: [],
    isLoading: undefined,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 12,
        sortBy: ['created_on'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['title', 'text', 'created_by'],
      andClauseFieldsIds: [],
    },
  },
});
